import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventOriginEnum } from '@app/core/enums/analytics/analytics-value.enum';
import { PermissionEnum } from '@app/core/enums/permissions.enum';
import { Contract, ContractInput } from '@app/core/model/entities/asset/contract';
import { Section } from '@app/core/model/other/field-config';
import { FormStateService } from '@app/shared/components/form-builder/form-state.service';
import { SectionService } from '@services/section.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  templateUrl: './organization-contract-create-modal.component.html',
  providers: [FormStateService],
  standalone: false
})
export class OrganizationContractCreateModalComponent implements OnInit {
  public formId = 'contract_creation_dialog';
  protected contractInput: ContractInput;
  protected eventsOrigin = EventOriginEnum.SHEET;
  public permissionsForEdition = [PermissionEnum.CREATE_CONTRACT];
  protected missingRequiredFields$: Observable<{ code: string, label: string }[]>;
  protected form: Section[];

  // Injection
  protected readonly formStateService = inject(FormStateService);
  private sectionService = inject(SectionService);
  protected readonly destroyRef = inject(DestroyRef);

  /**
   * Fetch accessible Assets and Spaces.
   */
  public ngOnInit(): void {
    this.missingRequiredFields$ = this.sectionService.getSectionsByFormCode(this.formId).pipe(
      tap(sections => this.form = sections),
      map(sections => sections.first()),
      map(section => this.sectionService.missingRequiredFields(section)),
      takeUntilDestroyed(this.destroyRef)
    );

    this.formStateService.saved$
      .pipe(
        tap(({data}) => {
          Contract.transformPropertiesForInput(data);
          this.contractInput = data;
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  /**
   * Get the form's data for creating a new Contract.
   * @return New Contract's data.
   */
  public getGeneratedObject(): ContractInput {
    return this.contractInput;
  }
}
